export default "__VITE_ASSET__BHHbDF9D__"